/* global axios */
// FLOW-06 (SPEC S5 e a emenda do Gate 2; PLAN G16; Task 6.3) — a lista de flows da conta, a seção
// Flows da aba PowerFlow (`PowerflowFlowsController#index`). Usa o axios global (carrega os headers de
// sessão).
//
// Um item por nome: `{nome, descricao, forma, publicada, rascunho, resumo}`, com a publicada mais nova
// (`{entrada_id, versao, args_schema, publicada_em}`, a que o "Executar agora" roda), o rascunho mais
// novo (`{entrada_id, versao}`) e o resumo do PowerTools (`{ultima, execucoes_24h, taxa_de_erro_24h}`),
// cada um nulo quando não há. A rota diz também quem monta flow (`pode_editar`: o super-admin, ou o
// gestor com a chave POWERFLOW_ADMIN_MONTA_FLOW).
const BASE = accountId => `/api/v1/accounts/${accountId}/powerflow/flows`;

export default {
  // `{flows, podeEditar}`. Sem `payload`, a lista sai vazia; o `pode_editar` só vale quando é `true`.
  index(accountId) {
    return axios.get(BASE(accountId)).then(({ data }) => ({
      flows: Array.isArray(data?.payload) ? data.payload : [],
      podeEditar: data?.pode_editar === true,
    }));
  },
};
